import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'

import { Media } from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  margin: -14px -36px;

  ${Media.Phone`
    margin: 0;
  `}
`

export const BannerContainer = styled.div`
  width: 100%;
  padding: ${Spacing['2XS']};

  ${Media.Phone`
    padding: 28px 0 20px;
  `}
`

export const InfoContainer = styled.div`
  width: 504px;

  display: flex;
  gap: ${Spacing.XS};
  flex-direction: column;

  text-align: center;
  margin-top: 40px;

  ${Media.Phone`
    margin-top: unset;
    width: 100%;
    padding: 0 20px;
  `}
`

export const Title = styled.h2`
  ${Typography.M};
  ${FontWeights.Medium};

  color: ${Colors.Neutral80};
`

export const Description = styled.p`
  ${Typography.Body};
  ${FontWeights.Regular};

  color: ${Colors.Neutral70};

  strong {
    ${FontWeights.Medium};
  }
`

export const ImageContainer = styled.div`
  margin: 24px 0 28px;

  ${Media.Phone`
    margin: 20px 0 12px;
  `}
`

export const Image = styled.img`
  width: 576px;
  height: 280px;
  object-fit: contain;

  ${Media.Phone`
    width: 100%;
    height: 100%;
  `}
`
